import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './search-dialog.style';

export const LoadingSearchResults: React.FC = () => (
  <Styled.LoadingContainer>
    <CircularProgress />
  </Styled.LoadingContainer>
);
